module.exports = __webpack_public_path__ + "static/media/ico_up.07f8cf71.svg";